
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";  

import CreditorSurvey from './CreditorSurvey.vue';
 
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType } from "@/types/Application";
import { creditorPersonInfoType } from '@/types/Application/Creditor';

@Component({
    components:{
      CreditorSurvey
    }
})
export default class CreditorInfo extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @Prop({required: true})
    creditorData!: creditorPersonInfoType[];

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.State
    public deceasedName!: string;
    
    showTable = true;
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;  
    updated = 0; 

    creditorPersonList: creditorPersonInfoType[] = [];

    mounted(){
        this.updated = 0;      
        this.creditorPersonList = JSON.parse(JSON.stringify(this.creditorData));
        Vue.nextTick(()=>this.surveyHasError());
    }   
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('creditor-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public creditorComponentData(value) {       
        this.showTable = value;
    }   

    public populateSurveyData(creditorValue) {

        const currentIndexValue = this.creditorPersonList?.length > 0 ? this.creditorPersonList[this.creditorPersonList.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCreditor = { ...creditorValue, id };
        this.creditorPersonList = [...this.creditorPersonList, newCreditor];
        this.updated++;

        this.$emit("creditorChange",this.creditorPersonList);
        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
       
        this.creditorPersonList = this.creditorPersonList.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.$emit("creditorChange",this.creditorPersonList);
        this.surveyHasError();
    }  

    public editRow(editedRow) {
        this.creditorPersonList = this.creditorPersonList.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.$emit("creditorChange",this.creditorPersonList);
        this.surveyHasError();
    }    

    public surveyHasError(){        
        this.incompleteError =  false;        
        for(const creditor of this.creditorPersonList){
            if (!creditor.creditorPersonName || !creditor.creditorPersonIsAlive){            
                this.incompleteError = true;
                break
            }
        }        
    }
    
}
